function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export const DEFAULT_TIMEOUT_MS = 10_000;
export class TimeoutError extends Error {
    constructor(taskName, timeoutMs, options){
        super(`'${taskName}' timed out after ${timeoutMs}ms`, options), _define_property(this, "taskName", void 0), _define_property(this, "timeoutMs", void 0), this.taskName = taskName, this.timeoutMs = timeoutMs;
        this.name = 'TimeoutError';
    }
}
export const withTimeout = (taskName, work, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const callSite = new Error(`withTimeout('${taskName}') call site`);
    let timer;
    const timeoutPromise = new Promise((_, reject)=>{
        timer = setTimeout(()=>{
            controller.abort();
            reject(new TimeoutError(taskName, timeoutMs, {
                cause: callSite
            }));
        }, timeoutMs);
    });
    return Promise.race([
        Promise.resolve().then(()=>work(controller.signal)).finally(()=>clearTimeout(timer)),
        timeoutPromise
    ]);
};

//# sourceMappingURL=with-timeout.js.map